<template>
  <div class="convert-loading-box">
    <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
    <div class="common-global-progress-box">
      <el-progress
        :show-text="false"
        :percentage="percentage"
        :stroke-width="8"
      >
      </el-progress>
      <div class="custom-text">
        <div class="text">{{ `${percentage}%` }}</div>
        <div class="progress-name-box text-overflow">
          {{ message ? message : "" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from "@/components/Spin.vue";
export default {
  data() {
    return {};
  },
  props: {
    percentage: Number,
    message: String,
  },
  components: {
    Spin,
  },
};
</script>

<style lang="less" scoped>
.convert-loading-box {
  .spinnner-container {
    position: absolute;
    width: 0px;
    left: 50%;
    top: 45%;
  }

  .common-global-progress-box {
    position: relative;
    top: 105px;
    display: flex;
    width: 180px;
    margin: 15px auto;
    line-height: 12px;

    /deep/ .el-progress {
      width: 80%;
      .el-progress-bar {
        line-height: 12px;
        border: 1px solid var(--base-primary-bgColor);
        padding: 1px;
        border-radius: 10px;

        .el-progress-bar__outer {
          background-color: transparent !important;

          .el-progress-bar__inner {
            line-height: 12px;
            background: var(--base-primary-bgColor);
          }
        }
      }
    }

    .custom-text {
      color: var(--base-primary-bgColor);
      margin-left: 10px;

      .text {
        color: var(--base-primary-bgColor);
      }

      .progress-name-box {
        position: absolute;
        top: 15px;
        left: 0px;
        width: 100%;
        font-size: 12px;
        color: var(--base-primary-bgColor);
        text-align: left;
      }
    }
  }
}
</style>